import { InsuranceInformationConstants } from './insuranceInformation.constants'
import {
  IInsuranceInformation,
  IInsuranceInformationAction,
  IInsuranceInformationState,
} from './insuranceInformation.types'

export const initialInsuranceInformation: IInsuranceInformation = {
  key: '',
  insuranceCarrier: '',
  groupName: '',
  groupNumber: '',
  policy: '',
  priority: null,
  insured: null,
  active: false,
  companyCoded: null,
}

export const initialInsuranceInformationState: IInsuranceInformationState = {
  insuranceInformationList: [],
  insuranceInformationData: initialInsuranceInformation,
  selectedInsuranceKey: null,
}

export function insuranceInformationReducer(
  state: IInsuranceInformationState = initialInsuranceInformationState,
  action: IInsuranceInformationAction
): IInsuranceInformationState {
  switch (action.type) {
    case InsuranceInformationConstants.SET_INSURANCE_CARRIER:
      return {
        ...state,
        insuranceInformationData: { ...state.insuranceInformationData, insuranceCarrier: action.insuranceCarrier },
      }
    case InsuranceInformationConstants.SET_GROUP_NAME:
      return { ...state, insuranceInformationData: { ...state.insuranceInformationData, groupName: action.groupName } }
    case InsuranceInformationConstants.SET_GROUP_NUMBER:
      return {
        ...state,
        insuranceInformationData: { ...state.insuranceInformationData, groupNumber: action.groupNumber },
      }
    case InsuranceInformationConstants.SET_POLICY:
      return { ...state, insuranceInformationData: { ...state.insuranceInformationData, policy: action.policy } }
    case InsuranceInformationConstants.SET_PRIORITY:
      return { ...state, insuranceInformationData: { ...state.insuranceInformationData, priority: action.priority } }
    case InsuranceInformationConstants.SET_INSURED:
      return { ...state, insuranceInformationData: { ...state.insuranceInformationData, insured: action.insured } }
    case InsuranceInformationConstants.SET_ACTIVE:
      return { ...state, insuranceInformationData: { ...state.insuranceInformationData, active: action.active } }
    case InsuranceInformationConstants.SET_INSURANCE_INFORMATION_LIST:
      return { ...state, insuranceInformationList: action.insuranceInformationList }
    case InsuranceInformationConstants.SET_SELECTED_INSURANCE:
      return { ...state, selectedInsuranceKey: action.selectedInsuranceKey }
    case InsuranceInformationConstants.REMOVE_INSURANCE_INFORMATION:
      return { ...state, selectedInsuranceKey: action.selectedInsuranceKey }
    case InsuranceInformationConstants.SET_INSURANCE_INFORMATION_STATE:
      return { ...action.insuranceInformationState }
    case InsuranceInformationConstants.SET_INSURANCE_INFORMATION_DATA:
      return { ...state, insuranceInformationData: action.insuranceInformationData }
    case InsuranceInformationConstants.CLEAR_INSURANCE_INFORMATION_DATA:
      return {
        ...state,
        insuranceInformationData: {
          key: '',
          insuranceCarrier: '',
          companyCoded: null,
          groupName: '',
          groupNumber: '',
          policy: '',
          priority: null,
          insured: null,
          active: false,
        },
      }
    case InsuranceInformationConstants.RESET_STATE:
      return {
        insuranceInformationData: {
          key: '',
          insuranceCarrier: '',
          companyCoded: null,
          groupName: '',
          groupNumber: '',
          policy: '',
          priority: null,
          insured: null,
          active: false,
        },
        insuranceInformationList: [],
        selectedInsuranceKey: null,
      }
    default:
      return state
  }
}
